import React, {useRef, forwardRef, memo} from 'react'
import Styles from './FJMediaHead.module.less';
import FJInputFile from "fj-components/FJInputFile"
import FJDropDown from "fj-components/FJDropDown";
import FJLocalStore from "../../../store/FJLocalStore";
import classNames from 'classnames'
import FJUtil from "../../../util/FJUtil";
import InlineSVG from "react-inlinesvg";
import FJButton from "fj-components/FJButton";
import importSvg from '../../../icon/local.svg';
import recordScreen from '../../../icon/record screen.svg';
import recordWebcam from '../../../icon/record webcam.svg';
import recordArrow from '../../../icon/recordarrow.svg';
import recordSvg from '../../../icon/record-btn.svg';
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJStockVideoButton from "./FJStockVideoButton";
import FJMediaHeadCloudContainer from "../container/FJMediaHeadCloudContainer";

function FJMediaHead(props) {
  let {
    onDataChange,
    screenClick,
    webCamClick,
    mediaOverSize,
    mediaOverNum,
    mediaNotSupport,
    uploadOnClick,
    isShow,
    isShowFiltrate,
    filtrateMediaType,
    updateFiltrateMediaTypeFun,
    openStockModal
  } = props;

  let cn = classNames(Styles.media_head, isShow ? 'show' : 'hide');

  return (
    <div className={cn}>
      <div className={Styles.header}>
        <div className={Styles.title}>{FJLocalStore._('upload-media')}</div>
        <FJMediaHeadCloudContainer />
      </div>
      <div className={Styles.head_content}>
        <FJStockVideoButtonMemo openStockModal={openStockModal}/>
        <FJUploadFileButtonMemo icon={importSvg}
                                text={FJLocalStore._('local-files')}
                                onDataChange={onDataChange}
                                type={['image', 'video', 'audio']}
                                mediaOverSize={mediaOverSize}
                                mediaOverNum={mediaOverNum}
                                mediaNotSupport={mediaNotSupport}
                                onClick={uploadOnClick}
        />
        <FJRecordButtonMemo screenClick={screenClick}
                            webCamClick={webCamClick}
        />
        {
          isShowFiltrate > 0 && <FJFiltrateMediaMemo filtrateMediaType={filtrateMediaType}
                                                     updateFiltrateMediaTypeFun={updateFiltrateMediaTypeFun}
          />
        }
      </div>
    </div>
  )
}

function FJUploadFileButton(props) {
  const inputFile = useRef(null);

  /**
   * @description 点击上传按钮触发文件上传
   * @private
   */
  const btnClick = () => {
    props.onClick();
    inputFile.current.click();
  };

  /**
   * @description 选择文件上传
   * @param e
   * @private
   */
  const onChange = (e) => {
    FJUtil.onFileDrop(e, props, () => {
      inputFile.current.val('');
    });
  };

  let {
    icon,
    text
  } = props;

  let acceptType = FJCoreUtil.getBrowser() === 'Safari' ? 'video/*, image/*, audio/*, video/mp4, video/x-m4v' : 'video/*, image/*, audio/*';

  return (
    <div>
      <div onClick={btnClick} className={Styles.upload_local}>
        <InlineSVG src={icon} className={Styles.left_icon}/>
        <span className={Styles.text}>{text}</span>
      </div>
      <FJInputFile ref={inputFile}
                   onChange={onChange}
                   multiple
                   accept={acceptType}/>
    </div>
  );
}

function FJRecordButton(props) {
  const dropDown = useRef(null);

  let {
    screenClick,
    webCamClick
  } = props;

  return (
    <FJDropDown overlay={
      <div className={Styles.list}>
        <div onClick={() => {
          dropDown.current.hide();
          screenClick();
        }} className={Styles.item}>
          <InlineSVG src={recordScreen}/>
          <span className={Styles.text}>{FJLocalStore._('record-screen')}</span>
        </div>
        <div onClick={() => {
          dropDown.current.hide();
          webCamClick();
        }} className={Styles.item}>
          <InlineSVG src={recordWebcam}/>
          <span className={Styles.text}>{FJLocalStore._('record-web-cam')}</span>
        </div>
      </div>
    }
                canTriggerActive
                useAnchorBody
                ref={dropDown}
                isTopLayer
                placement='bottomLeft'
    >
      <ForwardTrigger/>
    </FJDropDown>
  );
}

function FJFiltrateMedia(props) {
  let filtrateDropDown = useRef(null);

  let {
    filtrateMediaType,
    updateFiltrateMediaTypeFun
  } = props

  let list = [
    {
      title: 'all',
      type: 'all'
    },
    {
      title: 'videos',
      type: 'video'
    },
    {
      title: 'photos',
      type: 'image'
    },
    {
      title: 'audio',
      type: 'audio'
    }
  ];

  const _listComponent = (alignment) => {

    let html = [];
    for (let i = 0; i < list.length; i++) {
      const {title, type} = list[i];
      html.push((
        <FJButton text={FJLocalStore._(title)}
                  type='default'
                  className={classNames(Styles.screen_list)}
                  textClass={classNames(Styles.screen_list_text, {[Styles.active]: type === alignment})}
                  key={i}
                  onClick={() => {
                    filtrateDropDown.current.hide();
                    updateFiltrateMediaTypeFun(type)
                  }}
        />
      ))
    }

    return html;
  }

  return (
    <FJDropDown overlay={
      <div className={Styles.filtrate_list}>
        {_listComponent(filtrateMediaType)}
      </div>
    }
                zIndex={22}
                canTriggerActive={true}
                ref={filtrateDropDown}
                placement='bottomLeft'
    >
      <FiltrateTrigger text={FJLocalStore._(list.find(item => item.type === filtrateMediaType).title)}/>
    </FJDropDown>
  );

}

const ForwardTrigger = forwardRef(((props, ref) => {
  return (
    <div className={Styles.record} ref={ref}>
      <InlineSVG src={recordSvg} className={Styles.left_icon}/>
      <span className={Styles.text}>{FJLocalStore._('do-recording')}</span>
      <InlineSVG src={recordArrow} className={Styles.arrow}/>
    </div>
  );
}));
const FiltrateTrigger = forwardRef(((props, ref) => {
  let {
    text
  } = props

  return (
    <div className={Styles.media_filtrate_box}>
      <div className={Styles.media_filtrate} ref={ref}>
        <span className={Styles.text}>{text}</span>
        <InlineSVG src={recordArrow} className={Styles.arrow}/>
      </div>
    </div>
  );
}));
const FJUploadFileButtonMemo = memo(FJUploadFileButton);
const FJRecordButtonMemo = memo(FJRecordButton);
const FJFiltrateMediaMemo = memo(FJFiltrateMedia);
const FJStockVideoButtonMemo = memo(FJStockVideoButton);


export default FJMediaHead;
